import { useCallback, useState } from 'react';
import type { AxiosError } from 'axios';
import sendDelete from '../api/sendDelete';
import { useAuth } from '../context/AuthContext';

export default function useDeleteNews() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<null | AxiosError>(null);
  const { logout } = useAuth();

  const deleteNews = useCallback(
    (id: string, load: () => unknown) => {
      setLoading(true);
      sendDelete('intern/news', id)
        .then(load)
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            logout();
          } else {
            setError(err);
          }
        })
        .finally(() => setLoading(false));
    },
    [logout]
  );

  return { loading, error, deleteNews };
}
